var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClothing = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.416 7H17.916C17.916 8.2405 16.9065 9.25 15.666 9.25C14.4255 9.25 13.416 8.2405 13.416 7ZM22.2773 7.89625C21.3578 7.402 20.3955 7.123 19.4123 7.03825C19.3913 9.088 17.721 10.75 15.666 10.75C13.611 10.75 11.9408 9.088 11.9198 7.03825C10.9365 7.123 9.97427 7.40275 9.05477 7.89625C7.58177 8.6875 6.66602 10.2513 6.66602 11.977V13.768C6.66602 15.0107 7.67327 16.018 8.91602 16.018V13.75C8.91602 13.336 9.25202 13 9.66602 13C10.08 13 10.416 13.336 10.416 13.75V22C10.416 23.6567 11.7593 25 13.416 25H17.916C19.5728 25 20.916 23.6567 20.916 22V13.75C20.916 13.336 21.252 13 21.666 13C22.08 13 22.416 13.336 22.416 13.75V16C23.6588 16 24.666 14.9928 24.666 13.75V11.977C24.666 10.2513 23.7503 8.68675 22.2773 7.89625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_934"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(6.66602 7)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClothing);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/clothing.ce3f3a188ec05727154a9b8d54fd1b24.svg";